/**
 * Shared copyright footer — renders © year Product name.
 * Uses i18n with year/product interpolation.
 * Year formatted as Arabic numerals (٢٠٢٦) when language is Arabic.
 */
import { useTranslation } from "react-i18next";
import { usePageDirection } from "@/shared/hooks/usePageDirection";
import { toArabicNumerals } from "@/shared/lib/utils";

interface CopyrightFooterProps {
  className?: string;
}

export function CopyrightFooter({ className }: CopyrightFooterProps) {
  const { t } = useTranslation("common");
  const isRTL = usePageDirection() === "rtl";
  const year = new Date().getFullYear();
  const displayYear = isRTL ? toArabicNumerals(year) : String(year);

  return (
    <p
      className={className}
      dir={usePageDirection()}
      style={{
        color: "rgba(26,25,23,0.12)",
        fontFamily: "var(--font-sans)",
      }}
    >
      {t("copyright", { year: displayYear })}
    </p>
  );
}